module.exports = __webpack_public_path__ + "img/valoresHome_1_small.3cad0b95.jpg";